import * as React from "react";

export const ProductTags = ({ product, settings, isMobile }) => {
  const globals = settings?.globals;
  const badges = product?.tags || [];

  const badgeTexts = [
    badges.find((badge) => badge.startsWith(globals?.product_badges.badge_tags_check_1))
      ? globals?.product_badges.badge_tags_text_1
      : null,
    badges.find((badge) => badge.startsWith(globals?.product_badges.badge_tags_check_2))
      ? globals?.product_badges.badge_tags_text_2
      : null,
    badges.find((badge) => badge.startsWith(globals?.product_badges.badge_tags_check_3))
      ? globals?.product_badges.badge_tags_text_3
      : null,
    badges.find((badge) => badge.startsWith(globals?.product_badges.badge_tags_check_4))
      ? globals?.product_badges.badge_tags_text_4
      : null,
  ].filter(Boolean);

  const badgePosition = isMobile
    ? globals?.product_badge_position_mobile
    : globals?.product_badge_position_desktop;

  return (
    <>
      {badgePosition === 'on_product_image' ? (
        <div className={"absolute top-0 left-0 m-[4px] flex flex-col"}>
          {badgeTexts.map((badgeText, index) => (
            <p
              key={index}
              className="h6 font-semibold text-[12px] text-center py-[17px] px-[17px] flex w-fit uppercase"
            >
              {badgeText}
            </p>
          ))}
        </div>
      ) : (
        <div className={""}>
          {badgeTexts.map((badgeText, index) => (
            <p
              key={index}
              className="h6 font-semibold text-[12px] text-center pt-[12px] flex w-fit uppercase"
            >
              {badgeText}
            </p>
          ))}
        </div>
      )}
    </>
  );
};
